import "bootstrap/dist/css/bootstrap.min.css";
import "./fa-styles.css";
import "./swal-styles.css";
import "./App.css";
import { Principal } from "./components/Principal";
import { AppContext } from "./contexts/AppContext";
import { useContext, useEffect } from "react";
import { localState } from "./services/LocalState";

function App({ authTokenString, usuarioId}) {
    const {setAuthToken} = useContext(AppContext);

    useEffect(() => {

        localState.setLocalState("gu_token", authTokenString);
        localState.setLocalState("usuario_id", usuarioId);
        setAuthToken(authTokenString);

    }, [authTokenString, setAuthToken]);

    return (
        <div className="dommus-central-ajuda-app">
            <Principal />
        </div>
    );
}

export default App;
